import { useEffect, useRef, createContext, useContext } from "react";

// Context so Planet.js can notify cursor of hover
export const HoverContext = createContext({ hovering: null, setHovering: () => {} });

export const useHover = () => useContext(HoverContext);

// Planet accent colors — match themes.css
const PLANET_COLORS = {
  Sun:           "#FFA500",
  Earth:         "#4fc3f7",
  Jupiter:       "#c8a96e",
  Mars:          "#ef5350",
  Venus:         "#ffcc02",
  Saturn:        "#e8c97e",
  Neptune:       "#5c6bc0",
  Moon:          "#b0bec5",
  Mercury:       "#ff7043",
  Uranus:        "#80deea",
};

const SpaceCursor = () => {
  const dotRef  = useRef(null);
  const ringRef = useRef(null);
  const { hovering } = useContext(HoverContext);

  useEffect(() => {
    const dot  = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;

    const onMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      dot.style.left  = `${x}px`;
      dot.style.top   = `${y}px`;
      ring.style.left = `${x}px`;
      ring.style.top  = `${y}px`;
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  useEffect(() => {
    const ring = ringRef.current;
    if (!ring) return;
    if (hovering) {
      ring.classList.add("hovering");
      const color = PLANET_COLORS[hovering] || "#ff69b4";
      ring.style.setProperty("--cursor-color", color);
      ring.style.borderColor = color;
    } else {
      ring.classList.remove("hovering");
      ring.style.borderColor = "";
    }
  }, [hovering]);

  return (
    <>
      <div className="space-cursor-dot"  ref={dotRef}  />
      <div className="space-cursor-ring" ref={ringRef} />
    </>
  );
};

export default SpaceCursor;
